export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_TEMPLATE_LIST = 'SET_TEMPLATE_LIST';
export const SET_SELECTED_TEMPLATE = 'SET_SELECTED_TEMPLATE';
export const SET_TEMPLATE_MAPS_LIST = 'SET_TEMPLATE_MAPS_LIST';
export const SET_TEMPLATE_MAPS = 'SET_TEMPLATE_MAPS';
export const SET_SELECTED_TEMPLATE_MAP = 'SET_SELECTED_TEMPLATE_MAP';

export function setTemplates(templates) {
  return {
    type: SET_TEMPLATES,
    payload: templates,
  };
}

export function setTemplateList(list) {
  return {
    type: SET_TEMPLATE_LIST,
    payload: list,
  };
}

export function setSelectedTemplate(template) {
  return {
    type: SET_SELECTED_TEMPLATE,
    payload: template,
  };
}

export function setTemplateMaps(maps) {
  return {
    type: SET_TEMPLATE_MAPS,
    payload: maps,
  };
}

export function setTemplateMapList(maps) {
  return {
    type: SET_TEMPLATE_MAPS_LIST,
    payload: maps,
  };
}

export function setSelectedTemplateMap(map) {
  return {
    type: SET_SELECTED_TEMPLATE_MAP,
    payload: map,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/template/actions.js
 **/